const initailState = {
  singleAuctionData: [],
  loading: false,
};

export function singleAuctionReducer(state = initailState, { type, payload }) {
  switch (type) {
    case "GET_SINGLE_AUCTION":
      return { ...state, singleAuctionData: payload, loading: false };
    case "SINGLE_OFFER_LOADING":
      return { ...state, loading: true };
    case "SINGLE_OFFER_LOADDED":
      return { ...state, loading: false };
      case "COMPLETED_SINGLE_AUCTION_SUCCESS":
      return { ...state, singleAuctionData: payload, loading: false };
    case "COMPLETED_SINGLE_AUCTION_LOADING":
      return { ...state, loading: true };
    case "COMPLETED_SINGLE_AUCTION_FAILED":
      return { ...state, loading: false };
    default:
      return state;
  }
}
